(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("map-vertical-exaggeration", [], factory);
	else if(typeof exports === 'object')
		exports["map-vertical-exaggeration"] = factory();
	else
		root["map-vertical-exaggeration"] = factory();
})(self, function() {
return 